module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.data.disabled) ? _c('div', {
    staticClass: "provision"
  }, [_c('p', [_c('strong', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.body)
    }
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-433da6dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/block/BlockProvision.vue
// module id = 676
// module chunks = 0